import rulesMap from './data/rulesMap.json';

export function resolveRuleCode(ruleId) {
  const key = Object.keys(rulesMap).find((key) => rulesMap[key]?._id === ruleId);
  return key || ruleId;
}
